export enum LogoutTypeEnum {
    CURRENT_DEVICE = 'CURRENT_DEVICE',
    ALL_DEVICES = 'ALL_DEVICES',
}
